import React from 'react';
import { useFormContext } from 'react-hook-form';
import { AddTagFormData } from '../types';
import { FormToggle } from '../components/FormToggle';

export function BlockOtherAttributesSection() {
  const { control } = useFormContext<AddTagFormData>();

  const pantsAttributeOptions = [
    { label: 'Not Applicable', value: 'Not Applicable' },
    { label: 'Rigid', value: 'Rigid' },
    { label: 'Stretch', value: 'Stretch' },
  ];

  const topsAttributeOptions = [
    { label: 'Not Applicable', value: 'Not Applicable' },
    { label: 'Heavyweight', value: 'Heavyweight' },
    { label: 'Lightweight', value: 'Lightweight' },
  ];

  return (
    <div className="rounded-xl border border-neutral-200 shadow-sm p-5 space-y-4">
      <h3 className="text-lg font-medium text-gray-900">Other Attributes</h3>
      <p className="text-xs text-base-disabled">
        If your sample is for pants or tops, please choose the appropriate
        option.
      </p>

      <div className="space-y-2">
        <div className="flex items-center gap-4">
          <span className="text-sm font-medium text-gray-700 w-24">
            Pants<span className="text-danger-700 ml-1">*</span>
          </span>
          <FormToggle
            name="pantsAttribute"
            control={control}
            options={pantsAttributeOptions}
            rules={{
              validate: (value) =>
                value !== undefined || 'Please select a pants attribute',
            }}
          />
        </div>

        <div className="flex items-center gap-4">
          <span className="text-sm font-medium text-gray-700 w-24">
            Tops<span className="text-danger-700 ml-1">*</span>
          </span>
          <FormToggle
            name="topsAttribute"
            control={control}
            options={topsAttributeOptions}
            rules={{
              validate: (value) =>
                value !== undefined || 'Please select a tops attribute',
            }}
          />
        </div>
      </div>
    </div>
  );
}
